import { CustomInput, FormGroup, Label } from 'reactstrap';
import './reviewModal.scss';

const FormInputCustomWrapper = ({
  label,
  id,
  showError,
  error,
  children,
  ...other
}) => {
  return (
    <FormGroup>
      {label ? (
        <Label for={id} {...other} className={'label-text'}>
          {label}
        </Label>
      ) : null}
      <div>
        {children}
        {showError && (
          <div
            className='invalid-feedback d-block label-text'
            style={{ fontFamily: 'Brown' }}
          >
            {error}
          </div>
        )}
      </div>
    </FormGroup>
  );
};

const CustomFormRadioGroup = ({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  options,
  showError,
  error,
  notInline,
}) => (
  <FormInputCustomWrapper
    className={'label-text'}
    label={label}
    id={id}
    showError={showError}
    error={error}
  >
    <CustomRadioGroup
      className={'label-text'}
      name={name}
      id={id}
      value={value}
      onChange={onChange}
      options={options}
      onBlur={onBlur}
      inline={notInline ? false : true}
    />
  </FormInputCustomWrapper>
);

const CustomRadioGroup = ({
  name,
  value,
  options,
  inline = false,
  onChange,
  onBlur,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <>
      {options.map((child, index) => {
        return (
          <CustomInput
            key={`${name}_${child.value}_${index}`}
            type='radio'
            id={`${name}_${child.value}_${index}`}
            name={name}
            label={child.label}
            onChange={() => handleChange(child.value)}
            onBlur={handleBlur}
            checked={value === child.value}
            disabled={child.disabled}
            inline={inline}
            className={'label-text'}
          />
        );
      })}
    </>
  );
};

export { CustomRadioGroup, CustomFormRadioGroup, FormInputCustomWrapper };
